/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Constants from "variables/Constants";
// import editorConfiguration from "variables/EditorConfiguration";

const classes = makeStyles(styles);

export default class UpdateScannerChapter extends Component {
  state = {
    redirect: false,
    bAlert: false,
    notification: false,
    loading: false,
    level: "",
    subject: "",
    levels: [],
    subjects: [],
    aAlert: false,
    bAlert: false,
    cAlert: false,
    dAlert: false,
    eAlert: false,

    title: "",
    chapter_code: "",

    description: "",
  };

  componentDidMount() {
    let levelData = this.props.location.state.levelData;
    axios.get(Constants.getUrls.getlevel_without_paginate).then((resp) => {
      this.setState({
        levels: resp.data,
        level: levelData.scanner_level_id,
        subject: levelData.scanner_subject_id,
        title: levelData.title,
        description: levelData.description,
        chapter_code: levelData.chapter_code,
        status: levelData.status,
      });
    });

    axios.get(Constants.getUrls.getScannSubjectData).then((resp) => {
      console.log("Response Data:", resp.data); // Response data ko console par print karein

      this.setState({
        subjects: resp.data,
        title: levelData.title,
        description: levelData.description,
        status: levelData.status,
      });
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.level === "") {
      this.setState({
        aAlert: true,
      });
    } else if (this.state.title === "") {
      this.setState({
        bAlert: true,
      });
    } else if (this.state.chapter_code === "") {
      this.setState({
        eAlert: true,
      });
    }
    //  else if (this.state.description === "") {
    //   this.setState({
    //     cAlert: true,
    //   });
    // }
    else {
      this.setState({
        loading: true,
      });
      let payLoad = {
        scanner_level_id: this.state.level,
        scanner_subject_id: this.state.subject,
        title: this.state.title,
        chapter_code: this.state.chapter_code,
        // description: this.state.description,
        status: this.state.status,
      };
      let levelData = this.props.location.state.levelData;
      let levelId = levelData.id;
      axios
        .post(Constants.postUrls.updateScannerChapter + levelId, payLoad)
        .then((resp) => {
          setTimeout(() => {
            this.setState({
              redirect: true,
            });
          }, 1000);
          this.setState({
            notification: true,
            loading: false,
          });
        });
    }
  };

  handleChange(content) {
    this.setState(
      {
        description: content,
        bAlert: false,
      },
      () => {
        console.log(this.state.description);
      }
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/scannerchapter"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Chapter Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Scanner Chapter</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Title"
                          id="float"
                          inputProps={{
                            value: this.state.title,
                            required: true,
                            onChange: (e) =>
                              this.setState({
                                title: e.target.value,
                              }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Chapter Code"
                          id="float"
                          inputProps={{
                            value: this.state.chapter_code,
                            required: true,
                            onChange: (e) =>
                              this.setState({
                                chapter_code: e.target.value,
                              }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Level
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.level}
                            inputProps={{
                              name: "level",
                              id: "simple-select",
                              onChange: (e) => {
                                this.setState({
                                  level: e.target.value,
                                  bAlert: false,
                                });
                              },
                            }}
                          >
                            {this.state.levels.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.bAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Subject
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.subject}
                            inputProps={{
                              name: "subject",
                              id: "simple-select",
                              onChange: (e) => {
                                this.setState({
                                  subject: e.target.value,
                                  bAlert: false,
                                });
                              },
                            }}
                          >
                            {this.state.subjects.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.bAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>

                      {/* <GridItem xs={12} sm={12} md={12}>
                        <br />
                        <label>Description</label>
                        <br />
                        <SunEditor
                          // setOptions={editorConfiguration}
                          onChange={(content) => this.handleChange(content)}
                          setContents={
                            this.props.location.state.levelData.description
                          }
                        />
                        {this.state.cAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem> */}

                      <GridItem xs={12} sm={12} md={6}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? <Loader /> : "Update Chapter"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/scannerchapter",
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}
